<script>
import Layout from '@layouts/main'
import {
  orderReportMethods,
  customerMethods,
  toasterMethods,
} from '@state/helpers'
import { mapActions } from 'vuex'
import Trv4506tReport from '@components/BusinessCreditReport/trv4506treport'
import FloodReport from '@components/BusinessCreditReport/FloodReport/floodreport'
import servicelinkfloodreport from '@components/BusinessCreditReport/FloodReport/servicelinkfloodreport'
import TriMergeReport from '@components/BusinessCreditReport/trimergereport'
import BusinessCreditIndustryReport2 from '@components/BusinessCreditReport/BCIR2.0/bcir2.0'
import OFACPrincipalReport from '@components/BusinessCreditReport/OFAC/ofacprincipal'
import OFACCommercialReport from '@components/BusinessCreditReport/OFAC/ofaccommercial'
import LiensandJudgment from '@components/ConsumerCreditReport/LiensandJudgment/liensandJudgment'
import ExperianBusinessOwnerProfileReport from '@components/BusinessCreditReport/BusinessOwnerProfileReport/experianBusinessOwnerProfileReport'
import ExperianPremierProfileReport from '@components/BusinessCreditReport/PremierProfileReport/experianPremierProfileReport'
import ExperianBlendedReport from '@components/BusinessCreditReport/ExperianBlendedReport/experianBlendedReport'
import EquifaxBusinessPrincipleReport from '@components/BusinessCreditReport/EquifaxBusinessPrincipleReport/equifaxBusinessPrincipleReport'
import EquifaxPaynet from '@components/BusinessCreditReport/EquifaxPaynetReport/equifaxPaynet'
import FraudPlusPackage from '@components/FraudPlusReport/fraudplusreport'
import VerificationOfEmployment from '@views/Services/OrderReports/VerificationOfEmployment/voe-report'
import VerificationOfDeposit from '@views/Services/OrderReports/VerificationOfDeposit/vod-report'
import SelfEmployedVerification from '@views/Services/OrderReports/VOESelfEmployedVerification/voe-self-employed-verification-report'
import VerificationOfAsset from '@views/Services/OrderReports/VerificationOfAsset/voa-report'
import VerificationOfAssetFiserv from '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-report'
import UdnCreate from '@views/Services/OrderReports/UndisclosedDebtNotification/udnCreate'
import orderReportConstant from '@constants/orderreportconstant'
import constant from '@constants/constant'
import getPageAccessControl, {
  isReadOnly,
  canShowField,
} from '@/src/utils/access-controls'
import accesslevels from '@utils/accesslevels'

export default {
  page: {
    meta: [{ name: 'description', content: 'OrderReports' }],
  },
  components: {
    Layout,
    Trv4506tReport,
    FloodReport,
    servicelinkfloodreport,
    TriMergeReport,
    BusinessCreditIndustryReport2,
    OFACPrincipalReport,
    OFACCommercialReport,
    LiensandJudgment,
    ExperianBusinessOwnerProfileReport,
    ExperianPremierProfileReport,
    ExperianBlendedReport,
    EquifaxBusinessPrincipleReport,
    EquifaxPaynet,
    FraudPlusPackage,
    VerificationOfEmployment,
    VerificationOfAsset,
    VerificationOfAssetFiserv,
    VerificationOfDeposit,
    SelfEmployedVerification,
    UdnCreate,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    refineSearchAddOns: {
      type: Array,
      default: () => [],
    },
    callOrigin: {
      type: String,
      default: 'Services',
    },
    orderReportData: {
      type: Object,
      default: () => {},
    },
    enableManualVerificationMandatory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      permissionsLoaded: false,
      PAGE_MENU_ID: 138,
      busyState: [],
      oSearch: '',
      customer: '',
      customerUser: '',
      product: '',
      headerTitle: 'Order Report',
      dismissCountDown: 3,
      showSpinner: false,
      showmessage: false,
      selectedComponent: '',
      showModalAlert: false,
      alertBoxTitle: '',
      alertMessage: '',
      resultmessage: '',
      variant: 'warning',
      userInfo: '',
      enableDropdowns: false,
      userEmails: [],
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'Services',
          active: true,
        },
        { text: 'Order Report', active: true },
      ],
      customers: [],
      customerUsers: [],
      products: [],
      productAddons: [],
      orderData: {},
      orignalOrderData: {},
    }
  },

  computed: {
    isBusy() {
      return this.busyState.length
    },
    canShowCustomer() {
      return this.permissionsLoaded && canShowField('Customer')
    },
    canShowCustomerUser() {
      return this.permissionsLoaded && canShowField('Customer User')
    },
    canShowProducts() {
      return this.permissionsLoaded && canShowField('Product')
    },
    isNewOrderFlow() {
      return this.$store.getters['orderReport/selectedOrderType'] === 1
    },
    selectedOrderID() {
      return this.$store.getters['orderReport/selectedOrderID']
    },

    selectedOrderType() {
      return this.$store.getters['orderReport/selectedOrderType']
    },

    disableInputs() {
      if (
        this.callOrigin === 'voeResults' ||
        // Same callOrigin is used to disable dropdowns when navigated from  PPR
        this.callOrigin === 'bcir2Summary' ||
        this.callOrigin === 'blendedSearchResults' ||
        this.callOrigin === 'paynetSearchResults'
      ) {
        if (this.enableDropdowns) {
          return false
        }
        return true
      }
      return !this.isNewOrderFlow && !this.isNewOrderFromSummary
    },

    isNewOrderFromSummary() {
      return this.$store.getters['orderReport/isNewOrder']
    },

    isCreditAnalystOrLoanOfficer() {
      return !this.canShowCustomer && !this.canShowCustomerUser
    },

    fromOrderSummary() {
      return this.$store.getters['orderReport/fromOrderSummary']
    },
    getUserEmail() {
      let item = this.userEmails.filter(
        (item) => item.userID === this.customerUser
      )
      return item.length ? item[0].emailAddress : null
    },
  },

  watch: {
    products(from, to) {
      const includesAMS = to.find(
        (product) => product.text === 'Account Monitoring Services'
      )

      if (includesAMS) {
        const AMSindex = this.products.findIndex(
          (product) => product.text === 'Account Monitoring Services'
        )
        this.products.splice(AMSindex, 1)
      }
    },
  },
  mounted() {
    if (accesslevels(30)) {
      this.$router.push('home')
    }
    if (!this.$_allStates.length > 0) {
      this.getStateList()
    }
  },
  created() {
    this.getAccessControlData()
    if (this.search) {
      if (this.search.constructor === ''.constructor) {
        this.oSearch = JSON.parse(this.search)
      } else this.oSearch = this.search
    }
    this.userInfo = this.$store['getters']['auth/userInfo']
    if (this.oSearch) this.loadRefineData()
  },
  methods: {
    ...orderReportMethods,
    ...customerMethods,
    ...toasterMethods,
    ...mapActions({
      fetchMasterData: 'masterData/fetchMasterData',
    }),
    getAccessControlData() {
      this.busySet('acl')
      getPageAccessControl(this.PAGE_MENU_ID).then((access) => {
        this.showAlert()
        this.busyUnSet('acl')
        this.permissionsLoaded = true

        if (this.canShowCustomer) {
          this.getCustomers().then(() => {
            if (
              this.fromOrderSummary &&
              (this.isNewOrderFromSummary || !this.isNewOrderFlow)
            ) {
              this.getOrderDetails()
            }
          })
        }
        if (this.canShowCustomerUser) {
          if (!this.canShowCustomer) {
            if (
              this.fromOrderSummary &&
              (this.isNewOrderFromSummary || !this.isNewOrderFlow)
            ) {
              this.getOrderDetails()
            } else {
              this.getCustomerUsers()
            }
          }
        }
        // for CreditAnalystOrLoanOfficer && order from summary
        if (this.isCreditAnalystOrLoanOfficer && this.fromOrderSummary) {
          this.getOrderDetails()
        }
        if (
          this.canShowProducts &&
          !(this.isNewOrderFromSummary || !this.isNewOrderFlow)
        ) {
          this.getProducts()
        }
        if (
          this.canShowProducts &&
          (this.isNewOrderFromSummary || !this.isNewOrderFlow) &&
          !this.canShowCustomerUser
        ) {
          this.getProducts().then(() => {
            if (this.isCreditAnalystOrLoanOfficer) {
              this.product = '52'
              this.getProductComponent()
            }
          })
        }
      })
    },
    isReadOnly(field) {
      return isReadOnly(field)
    },
    busySet(id) {
      this.showSpinner = true
      this.busyState.push(id)
    },
    busyUnSet(id) {
      this.busyState.splice(this.busyState.indexOf(id), 1)
      this.showSpinner = this.isBusy
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    loadRefineData() {
      this.getCustomers().then(() => {
        if (this.oSearch) {
          let orderForCustomer = this.oSearch.OrderForCustomer
          if (this.canShowCustomer) {
            this.customer = this.customers.find(
              (customer) => customer.value === orderForCustomer
            )
          }
        }

        this.getCustomerUsers()
          .then(() => {
            this.customerUser = this.oSearch.OrderForUser
          })
          .then(() => {
            this.getProducts().then(() => {
              this.product = this.oSearch.ProductId
              this.orderData = this.orderReportData
              this.getProductComponent()
            })
          })
      })
    },
    resetOrderReport() {
      this.enableDropdowns = true
      this.enableManualVerificationMandatory = false
      this.selectedComponent = ''
      this.product = ''
      this.products = []
      if (!this.canShowCustomer) {
        this.customerUser = this.userInfo.userId
        this.customer = this.userInfo.customerId
      } else {
        this.customerUsers = []
        this.customerUser = ''
        this.customer = ''
      }
    },
    alertDismissed(dismissCountDown) {
      this.showmessage = false
    },

    async getOrderDetails() {
      this.busySet('orderDetails')
      this.getCCROrderData(this.selectedOrderID)
        .then((response) => {
          this.orderData = response.data
          this.orignalOrderData = response.data
          if (this.customers.length) {
            this.customer = this.customers.find(
              (customer) => customer.value === response.data.forCustomerID
            )
          }
          if (this.canShowCustomer || this.canShowCustomerUser) {
            this.getCustomerUsers()
              .then(() => {
                this.customerUser = response.data.forUserID
              })
              .then(() => {
                this.getProducts().then(() => {
                  this.product = response.data.productId
                  this.getProductComponent()
                })
              })
          }
        })
        .finally(() => this.busyUnSet('orderDetails'))
    },

    getCustomers() {
      this.busySet('customer')
      this.customerUser = ''
      this.product = ''
      return this.fetchCustomersByUserId()
        .then((response) => {
          this.customers = []
          response.customers.forEach((eachCustomer) => {
            this.customers.push({
              text: eachCustomer.customerAccNumber + '-' + eachCustomer.name,
              value: eachCustomer.customerId,
            })
          })
        })
        .catch((error) => {
          this.authError = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
        .finally(() => this.busyUnSet('customer'))
    },
    getCustomerUsers() {
      this.products = []
      this.customerUsers = []
      this.customerUser = ''
      this.selectedComponent = ''
      this.product = ''
      let customerVal
      let _tempCustomer = this.customer.value || this.customer
      if (!_tempCustomer) {
        if (this.canShowCustomerUser) {
          customerVal = this.userInfo.customerId
        }
      } else {
        customerVal = this.customer.value || this.customer
      }
      if (!customerVal) {
        return false
      }
      this.busySet('custUser')
      return this.fetchCustomerUser({
        customerId: customerVal,
      })
        .then((response) => {
          response.data.forEach((user) => {
            this.customerUsers.push({
              text: user.userFullName,
              value: user.userID,
            })
            this.userEmails.push({
              userID: user.userID,
              emailAddress: user.emailAddress,
            })
          })
          if (!this.canShowCustomer && this.canShowCustomerUser) {
            this.customerUser = this.userInfo.userId
          }
        })
        .catch((error) => {
          this.authError = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
        .finally(() => this.busyUnSet('custUser'))
    },
    getProducts() {
      this.products = []
      this.product = ''
      this.selectedComponent = ''
      let userInfo = this.$store.state.auth.currentUser.userInfo
      if (!this.canShowCustomer) {
        this.customerUser = this.customerUser || userInfo.userId
        let customerID = this.customer || userInfo.customerId
        this.customer = customerID.value ? customerID : { value: customerID }
      }
      if (this.customerUser !== '') {
        this.busySet('product')
        return this.fetchUserProduct({
          userId: this.customerUser,
        })
          .then((response) => {
            response.data.forEach((product, index) => {
              this.products.push({
                text: product.name,
                value: product.productId,
              })
              this.productAddons[response.data[index].productId] =
                response.data[index].productAddOns
            })
          })
          .catch((error) => {
            this.authError = error
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
          })
          .finally(() => this.busyUnSet('product'))
      }
    },
    getProductComponent() {
      if (
        (Number(this.product) === 52 && this.isNewOrderFlow) ||
        this.isNewOrderFromSummary
      ) {
        this.checkOrderLimits(this.product)
      } else {
        this.showProductComponent(this.product)
      }
    },
    checkOrderLimits(prodCode) {
      this.busySet('checklimit')
      let customerUser = this.customerUser || this.$store.getters['auth/userId']
      let limitData = { productId: prodCode, customerUser: customerUser }
      return this.fetchOrderLimits(limitData)
        .then((response) => {
          let responseData = response.data || response
          if (responseData.id === 2) {
            this.resultmessage = responseData.message
            this.showmessage = true
            this.showProductComponent(prodCode)
          } else if (responseData.id === 3) {
            this.alertBoxTitle = 'Order Limits'
            this.alertMessage = responseData.message
            this.showModalAlert = true
            this.showProductComponent('')
          } else {
            this.showProductComponent(prodCode)
          }
        })
        .catch((error) => {
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
          this.autherror = error
        })
        .finally(() => this.busyUnSet('checklimit'))
    },
    showProductComponent(productCode) {
      let componentName = []
      let allReports = orderReportConstant.orderReports
      let reportFilter = (report) => report.value === parseInt(productCode)
      componentName = allReports
        .filter(reportFilter)
        .map((report) => `${report.text}`)
      this.selectedComponent = componentName[0]
    },
    confirmClicked() {
      this.showModalAlert = false
    },
    onDataSubmit(event) {
      // Clearing the selected product after submit the pages.
      this.product = ''
    },
    async getStateList() {
      this.showSpinner = true
      let masterApiResponse = await this.fetchMasterData()
      if (masterApiResponse.status === 200) {
        this.showSpinner = false
      } else {
        this.setAlert({
          title: constant.imageHeaderError,
          msg: 'Master Data API failed to load',
          variant: constant.errorMessagetype,
        })
        this.showSpinner = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />
    <BaseBreadcrumb class="px-3" :crumbs="breadcrumbs" />
    <BaseModalAlert
      :modal-show="showModalAlert"
      :title-header="alertBoxTitle"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    >
    </BaseModalAlert>
    <BaseAlert
      v-if="showmessage"
      class="w-25"
      :class="$style.alertMsgPosition"
      :variant="variant"
      @alertDismissed="alertDismissed"
      @dismiss-count-down="countDownChanged"
    >
      {{ resultmessage }}
    </BaseAlert>

    <div id="report-hldr" class="body--wrapper mt-1 bg-white container">
      <BaseTitleMenu :heade-title="headerTitle" />

      <b-form>
        <div v-if="canShowCustomer || canShowCustomerUser">
          <b-row align-v="center">
            <b-col md="auto">
              <div>
                <BaseELabel label="On Behalf of" />
              </div>
            </b-col>
            <b-col class="mr-4 border-bottom"></b-col>
          </b-row>
          <b-row align-v="center" class="mx-3">
            <b-col v-if="canShowCustomer" class="d-inline-block col-4">
              <BaseELabel mark-required label="Customer" />
              <BaseMultiSelect
                v-model="customer"
                v-validate="'required'"
                type="text"
                :options="customers"
                :multiple="false"
                name="customer"
                mark-required
                placeholder="Select"
                data-vv-as="Customer[s]"
                label="text"
                track-by="value"
                :close-on-select="true"
                :clear-on-select="false"
                :class="$style.dropOptionstyle"
                :disabled="disableInputs || isReadOnly('Customer')"
                @close="getCustomerUsers"
              />
            </b-col>
            <b-col v-if="canShowCustomerUser" md="4" class="d-inline-block">
              <BaseELabel mark-required label="Customer User" />
              <BaseMultiSelect
                v-model="customerUser"
                v-validate="'required'"
                type="text"
                :options="customerUsers.map((cu) => cu.value)"
                :custom-label="
                  (opt) =>
                    (customerUsers.find((x) => x.value === opt) || {}).text
                "
                class="mb-1 dropdownstyle"
                :multiple="false"
                name="customerUser"
                mark-required
                placeholder="Select"
                data-vv-as="Customer User"
                label="text"
                :close-on-select="true"
                :clear-on-select="false"
                :class="$style.dropOptionstyle"
                :disabled="disableInputs || isReadOnly('Customer User')"
                @close="getProducts"
              />
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="border-bottom mx-3"> </b-col>
          </b-row>
        </div>

        <b-row v-if="canShowProducts" class="mx-3 mb-3">
          <b-col md="4">
            <BaseELabel mark-required label="Choose Product" />
            <BaseDropdown
              v-model="product"
              v-validate="'required'"
              type="text"
              :options="products"
              name="product"
              mark-required
              :class="$style.dropOptionstyle"
              :is-disabled="disableInputs || isReadOnly('Product')"
              @change="getProductComponent"
            ></BaseDropdown>
          </b-col>
        </b-row>

        <b-row class="mx-3">
          <b-col>
            <component
              :is="selectedComponent"
              :key="product"
              v-bind="{
                customerId: customer.value,
                customerUserId: customerUser,
                productId: product,
                productAddOns: productAddons[product],
                searchData: search,
                refineSearchAddOns: refineSearchAddOns,
                orderType: selectedOrderType,
                orderID: selectedOrderID,
                orderData: orderData,
                orignalOrderData: orignalOrderData,
                enableManualVerificationMandatory: enableManualVerificationMandatory,
                userEmail: getUserEmail,
              }"
              @resetOrderReport="resetOrderReport"
            ></component>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </Layout>
</template>
<style lang="scss" module>
@import '@design';

.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}

.btnHover:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
}

.containerWidth {
  max-width: $size-container-max-width;
}

.dropOptionstyle option {
  font-size: 16px;
}

.alertMsgPosition {
  position: absolute;
  top: 3rem;
  right: 0;
  z-index: 9999;
}
</style>
